<style src="./Showcase.scss" lang="scss"></style>

<template lang="pug">
  section.showcase(
    :class='`is-${view || "card"}`'
  )
    header.showcase__header
      .showcase__headline
        h2.showcase__title {{ title }}
        p.showcase__caption(
          v-if='caption'
        ) {{ caption }}
      router-link.showcase__link(
        v-if='url && items.length > 4'
        :to='url'
      ) {{ $l10n('MORE') }}
    .showcase__body(
      ref='body'
    )
      p.itemlist__message(
        v-if='!items.length'
      ) {{ emptyMessage }}

      ul.showcase__list(
        v-else
        ref='list'
        :class='{"grid is-columns": view !== "list"}'
      )
        li.showcase__item(
          v-for='(item, index) in items'
          :style='{"z-index": view === "list" ? items.length - index : null }'
          :class='{"col-20p col-lg-3 col-m-4 col-s-6": view !== "list"}'
        )
          Track(
            v-if='item && type === "tracks"'
            type='card'
            :index='index'
            :track='item'
            :tracklist='tracklist'
          )
          Track(
            v-if='item && type === "tracklist"'
            type='list'
            :index='index'
            :track='item'
            :tracklist='tracklist'
          )
          Album(
            v-if='item && type === "albums"'
            type='card'
            :album='item'
          )
          Artist(
            v-if='item && type === "artists"'
            type='card'
            :artist='item'
          )
          Genre(
            v-if='item && type === "genres"'
            type='card'
            :genre='item'
          )
</template>
<script>
import Track from "@/components/Track/Track";
import Album from "@/components/Album/Album";
import Artist from "@/components/Artist/Artist";
import Genre from "@/components/Genre/Genre";
import Helpers from "@/services/helpers";

export default {
  props: ["emptyMessage", "items", "url", "title", "caption", "type", "view"],
  components: { Track, Album, Artist, Genre },
  computed: {
    tracksIds() {
      return this.items.filter(track => Boolean(track)).map(track => track.id);
    },
    tracklist() {
      return {
        id: Helpers.getTracklistId(this.tracksIds),
        tracks: this.tracksIds
      };
    }
  }
};
</script>
